import { useTranslation } from 'react-i18next';
import { Option } from '@anytag/shared-types';
import { Form } from '@anytag/shared-atoms';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import {
  MarketplaceAffiliateCommissionStatus,
  useMarketplaceAffiliateCommissionFixedDatesQuery
} from '@anytag/graphql';
import { MarketplaceCommissionsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  marketplaceId: number;
  onSubmit?: () => void;
}

export const Template = ({ onSubmit, marketplaceId }: TemplateProps) => {
  const { t } = useTranslation();
  const { data } = useMarketplaceAffiliateCommissionFixedDatesQuery({ variables: { marketplaceId } });

  const monthOptions: Option[] =
    data?.marketplaceAffiliateCommissionFixedDates?.map((date, i) => ({
      value: `${date}_${i}`,
      label: typeof date === 'string' ? date : '-'
    })) || [];
  const statusOptions = useTranslateOptions([
    { label: 'Approved', value: MarketplaceAffiliateCommissionStatus.APPROVED },
    { label: 'Not Approved', value: MarketplaceAffiliateCommissionStatus.UNAPPROVED }
  ]);

  return (
    <Form.Fields>
      <TextSearchField<MarketplaceCommissionsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.InfluencerFilter')}
      />

      <SelectorField<MarketplaceCommissionsFilterFormKeys>
        name="month"
        onSubmit={onSubmit}
        className="max-w-50"
        options={monthOptions}
        placeholder={t<string>('Selector.Month')}
      />

      <SelectorField<MarketplaceCommissionsFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        className="max-w-50"
        options={statusOptions}
        placeholder={t<string>('Selector.Status')}
      />
    </Form.Fields>
  );
};
